<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="评价人" prop="adminid">
            <remote-select class="width-max"
                           v-model="search.adminid"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="keyword"
                           placeholder="请输入评价人进行搜索"
                           :query-request="queryReturnOrderEvalEvaluatorOptionsApi"
                           :find-request="findEvaluatorById">
            </remote-select>
          </el-form-item>
          <el-form-item label="退单人" prop="return_adminname">
            <remote-select class="width-max"
                           v-model="search.return_adminname"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="keyword"
                           placeholder="请输入退单人搜索"
                           :query-request="queryReturnOrderEvalReturnAdminOptionsApi">
            </remote-select>
          </el-form-item>
          <el-form-item label="工单ID" prop="orderid">
            <el-input v-model="search.orderid"
                      class="width-max"
                      clearable
                      placeholder="请输入工单ID">
            </el-input>
          </el-form-item>
          <el-form-item label="是否规范" prop="is_standard">
            <el-select v-model="search.is_standard"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">
            搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearchResult()">
            按搜索结果导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         width="100">
        </el-table-column>
        <el-table-column prop="orderid"
                         label="工单ID"
                         width="120">
          <template slot-scope="scope">
            <router-link :to="`/order/detail/${scope.row.orderid}`">
              <span class="blue-color">ORD{{ scope.row.orderid }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="评价人"
                         width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.adminname">
              {{ scope.row.adminname }}/{{ scope.row.adminid || '-' }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="return_adminname"
                         label="退单人"
                         width="160"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="是否规范"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{ formatYesNo(scope.row.is_standard) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="不规范原因"
                         min-width="240"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ formatNonStandardReason(scope.row.non_standard_reason) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         width="160">
        </el-table-column>
        <el-table-column label="操作"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <el-button type="primary"
                       size="mini"
                       @click="onViewOrder(scope.row)">
              查看工单
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import { getPlatformUsersDetail } from '@/views/platform-user/platform-user.api'

export default {
  name: 'ReturnOrderEvaluationTable',
  mixins: [table],
  data () {
    return {
      searchFieldType: {
        adminid: Number,
        orderid: Number,
        is_standard: Number,
      },
      search: {
        adminid: null,
        return_adminname: null,
        orderid: '',
        is_standard: null,
      },
      exportHeader: {
        id: 'ID',
        orderid: '工单ID',
        admin: '评价人',
        return_adminname: '退单人',
        is_standard: '是否规范',
        non_standard_reason: '不规范原因',
        created_at: '创建时间',
      },
    }
  },
  methods: {
    ...request.map([
      'queryReturnOrderEvalEvaluatorOptionsApi',
      'queryReturnOrderEvalReturnAdminOptionsApi',
    ]),
    /**
     * 评价人：与复核列表等页一致，按 admin id 从主平台拉取姓名，避免刷新后只显示数字
     */
    findEvaluatorById (params) {
      return getPlatformUsersDetail(params || {}).then((res) => {
        const body = res && res.data
        let item = body
        if (body && body.detail) {
          const candidate = body.detail
          item = (candidate && (candidate.id != null || candidate.name != null)) ? candidate : body
        }
        return { data: item }
      })
    },
    getTableData (params) {
      return request.common('queryReturnOrderEvaluationTableApi', params)
    },
    formatYesNo (val) {
      const v = parseInt(val)
      if (v === 1) return '是'
      if (v === 0) return '否'
      return '-'
    },
    formatNonStandardReason (reasons) {
      if (!reasons) return '-'
      if (Array.isArray(reasons)) {
        return reasons.filter(Boolean).join('/') || '-'
      }
      return String(reasons)
    },
    onExportSearchResult () {
      this.$export('退单评价列表', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          const rows = (data && data.data) || []
          return Object.assign({}, data, {
            data: rows.map(row => {
              const reasons = this.formatNonStandardReason(row.non_standard_reason)
              return Object.assign({}, row, {
                admin: `${row.adminname || ''}/${row.adminid || ''}`,
                is_standard: this.formatYesNo(row.is_standard),
                non_standard_reason: reasons,
              })
            }),
          })
        },
      })
    },
    onViewOrder (row) {
      const orderId = parseInt(row && row.orderid)
      if (!orderId) {
        this.$message.error('工单ID无效，无法跳转')
        return
      }
      this.$router.push(`/order/review/${orderId}`)
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}

.blue-color {
  color: rgb(88, 157, 248);
}
</style>




// WEBPACK FOOTER //
// src/views/audit-task-setting/pages/ReturnOrderEvaluationTable.vue